export const maintenance = false;
const base_url = (env) => {
    const base_urls = {
        dev: "https://4a8k7dr4m6.execute-api.ap-southeast-1.amazonaws.com/dev",
        prod: "https://lc3aqhpow5.execute-api.ap-southeast-1.amazonaws.com/prod",
        qa: "https://d73vw5es1k.execute-api.ap-southeast-1.amazonaws.com/qa",
        stage: "https://api.onestoplms.com/stage",
    };
    return base_urls[env];
};
const cognito_user_pool_id = (env) => {
    return {
        dev: "ap-southeast-1_IcsZv9o5E",
        qa: "ap-southeast-1_mte93nHbG",
        stage: "ap-south-1_4TDGecZOr",
        prod: "ap-southeast-1_Czs32VofK",
    }[env];
};
const ws_url = (env) => {
    return {
        dev: "wss://i4ous4f4l0.execute-api.us-east-1.amazonaws.com/lms-meetmates-dev?meeting_id=lms",
        prod: "wss://i4ous4f4l0.execute-api.us-east-1.amazonaws.com/lms-meetmates-prod?meeting_id=lms",
        qa: "wss://i4ous4f4l0.execute-api.us-east-1.amazonaws.com/lms-meetmates-qa?meeting_id=lms",
        stage: "wss://t5amv1zl2h.execute-api.us-east-1.amazonaws.com/lms-meetmates-stage?meeting_id=lms",
    }[env];
};
const social_api_url = (env) => {
    return {
        dev: "https://saaslms-auth-stack.auth.ap-southeast-1.amazoncognito.com",
        prod: "https://saaslms-auth-stack-prod.auth.ap-southeast-1.amazoncognito.com",
        qa: "https://saaslms-auth-stack-qa.auth.ap-southeast-1.amazoncognito.com",
        stage: "https://auth-stage.onestoplms.com",
    }[env];
};
const cloudfront_url = (env) => {
    return {
        dev: "https://d2d10mhtzdk01w.cloudfront.net/",
        prod: "https://ds3u277awq2am.cloudfront.net/",
        qa: "https://dgz1uc0a4j3xz.cloudfront.net/",
        stage: "https://streamstage.onestoplms.com/",
    }[env];
};
const identity_id = (env) => {
    return {
        dev: "ap-southeast-1:ea2fe236-2801-4807-9de4-0549b3915fc4",
        qa: "ap-southeast-1:d5084150-33ff-4138-ba72-349c5fa4723a",
        stage: "ap-south-1:732e1453-64bc-4be3-af8f-c4258fcd453e",
        prod: "ap-southeast-1:b8d1e8a6-e1ba-44ac-9dce-101968e21e2d",
    }[env];
};
const _bucket = (env) => {
    return {
        dev: "saaslms-media-conversion-source-bucket-dev",
        qa: "saaslms-media-conversion-source-bucket-qa",
        prod: "saaslms-media-conversion-source-bucket-prod",
        stage: "oslms-media-conversion-stack-source-bucket-stage",
    }[env];
};
const cognito_app_id = (env) => {
    return {
        dev: "3lbd5nscbbpr0nft8gcvj8s1lu",
        qa: "2ai4ufho7jriv693gt6ielc4v6",
        stage: "7dkj1sic99phkeh3an9ov5mfm9",
        prod: "58b2hpkm6fes22s5fh7qoigptp",
    }[env];
};
const auth0_app_id = (env) => {
    return {
        dev: "1nAVwKMKb5zPySy34aTfRFR2KKPdBsFi",
        qa: "1nAVwKMKb5zPySy34aTfRFR2KKPdBsFi",
        stage: "1nAVwKMKb5zPySy34aTfRFR2KKPdBsFi",
        prod: "1nAVwKMKb5zPySy34aTfRFR2KKPdBsFi",
    }[env];
};
const web_url = (env) => {
    return {
        dev: "https://dev.d2aqmhsey9nwi7.amplifyapp.com",
        qa: "https://qa.d2aqmhsey9nwi7.amplifyapp.com",
        prod: "https://www.alimaaninstitute.com",
        stage: "https://app.alimaaninstitute.com",
    }[env];
};
const admin_url = (env) => {
    return {
        dev: "https://dev.d1utbflr7sww24.amplifyapp.com",
        qa: "https://qa.d1utbflr7sww24.amplifyapp.com",
        stage: "https://adminapp.onestoplms.com",
        prod: "https://admin.alimaaninstitute.com"
    }[env];
};
const site_key = (env) => {
    return {
        dev: "6Lc89ucqAAAAACwn3OCEZUqBnhv84cNrffs0UaWx",
        prod: "6LdW-1ArAAAAAL0abcgAeiDhj5W06CqDjPMzGTpH"
    }[env];
};
export const status = process.env.REACT_APP_ENV_MODE || "prod";
export const web_base_url = web_url(status);
export const admin_base_url = admin_url(status);
export const api_base_url = base_url(status);
export const ws_base_url = ws_url(status);
export const recaptcha_site_key = site_key(status);
export const cookie_url_endpoint = ".alimaaninstitute.com";
export const auth0_redirected_endpoint = "dev-login";
export const social_api_base_url = social_api_url(status);
export const cloudfront_base_url = cloudfront_url(status);
export const cognitoUserPoolId = cognito_user_pool_id(status);
export const identityPoolId = identity_id(status);
export const bucket = _bucket(status);
export const region = "ap-southeast-1";
export const cognito_app_client_id = cognito_app_id(status);
export const auth0_app_client_id = auth0_app_id(status);
export const DEFAULT_LANGUAGE = "en";
export const messengerChatId = "109832122030902";